import { HoverCard, Text, ThemeIcon } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import { getReportingRateColor } from "../../../functions/utilFunctions";
import { useLanguage } from "../../../stores/LanguageStore";

const ReportingInfo = ({ children, ...props }) => {
  return (
    <HoverCard position="top" withArrow>
      <HoverCard.Target>
        <ThemeIcon variant="subtle" {...props}>
          <IconInfoCircle />
        </ThemeIcon>
      </HoverCard.Target>

      <HoverCard.Dropdown maw={300}>{children}</HoverCard.Dropdown>
    </HoverCard>
  );
};

export const ReportingScaleText = () => {
  const lang = useLanguage((s) => s.language);
  return (
    <>
      <Text mb={-12}>{lang.reports.scale}:</Text>
      <ul>
        <li>
          <Text c={getReportingRateColor(4)}>0 - 4 : {lang.reports.weak}</Text>
        </li>
        <li>
          <Text c={getReportingRateColor(7)}>
            4 - 7 : {lang.reports.average}
          </Text>
        </li>
        <li>
          <Text c={getReportingRateColor(10)}>
            7 - 10 : {lang.reports.good}
          </Text>
        </li>
        <li>
          <Text c={getReportingRateColor(11)}>
            {" "}
            {">"} 10 : {lang.reports.excellent}{" "}
          </Text>
        </li>
      </ul>
    </>
  );
};

export default ReportingInfo;
